import React from "react";
import { LegalPage } from "../../components/legal-page";
import { usePraxis } from "../../praxis-config/praxis-context";

export const ImprintPage: React.FC = () => {
  const { config } = usePraxis();

  return <LegalPage page={config.legal.imprint} />;
};
